import type { AutocompleteOption, AutocompleteProps } from '../../../types';

interface AutocompleteIconProps {
    option: AutocompleteOption | null;
    vertical: AutocompleteProps['vertical'];
    departure?: AutocompleteProps['departure'];
    className?: string;
}

const getIconName = ({ option, vertical, departure = true }: AutocompleteIconProps): string | null => {
    if (vertical === 'flight' && option?.locationType === 'CITY') {
        return 'PinMarker';
    }

    if (vertical === 'flight' && departure === false) {
        return 'PlaneLand';
    }

    if (vertical === 'hotel' && option?.type === 'hotel') {
        return 'Building';
    }

    if (vertical === 'car' && option?.type === 'Flyplass') {
        return departure ? 'PlaneTakeOff' : 'PlaneLand';
    }

    if (vertical === 'car' && option?.type === 'By / Område') {
        return 'PinMarker';
    }

    switch (vertical) {
        case 'flight':
            return 'PlaneTakeOff';
        case 'hotel':
            return 'PinMarker';
        case 'car':
            return 'Car';
        case 'prepackage':
            return 'PinMarker';
        case 'fhh':
            return 'PinMarker';
        default:
            return null;
    }
};

export const AutocompleteIcon = ({ option, vertical, className, departure = true }: AutocompleteIconProps) => {
    const name = getIconName({ option, vertical, departure });

    return name ? <w-icon name={name} size="small" aria-hidden className={className} /> : null;
};
